import { render, staticRenderFns } from "./TopicStemDescription.vue?vue&type=template&id=2948a23a&"
import script from "./TopicStemDescription.vue?vue&type=script&lang=js&"
export * from "./TopicStemDescription.vue?vue&type=script&lang=js&"
import style0 from "./TopicStemDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports